import { Component, Host, h, Element, Prop } from "@stencil/core";

/**
 * @slot - Slot for multiple elements
 * @slot label - Slot for label (alternative for label property)
 */
@Component({
  tag: "stzh-eventdata",
  styleUrl: "stzh-eventdata.scss",
  scoped: true,
})
export class StzhEventdata {
  /** Label (use label slot as alternative) */
  @Prop() label: string = "";

  @Element() element: HTMLStzhEventdataElement;

  render() {
    const classes = {
      "stzh-eventdata": true,
    };

    return (
      <Host>
        <div class={classes}>
          <div class="stzh-eventdata__label">{this.label ? this.label : <slot name="label"></slot>}</div>
          <div class="stzh-eventdata__content">
            <slot></slot>
          </div>
        </div>
      </Host>
    );
  }
}
